import { createTheme } from '@mui/material/styles'

// Types
import type { Direction } from '@mui/material/styles'

// Fonts
import IranSansXFont from '@/styles/fonts/iran-sans-x'
import RobotoFont from '@/styles/fonts/roboto'

// Utils
import { uiScalePopoverTransitionSlotProps, uiScalePopperModifiers } from '@/utils/ui/scale'

const ThemeConfig = (dir: Direction) =>
	createTheme({
		direction: dir,
		cssVariables: { colorSchemeSelector: 'class' },
		palette: {
			primary: { ultralight: '#e6f5f5', light: '#c4f1f3', main: '#69dbdf', dark: '#24a6aa', ultradark: '#145a5c', contrastText: '#000' },
			secondary: { ultralight: '#ecd9b4', light: '#d9b265', main: '#c29130', dark: '#856321', contrastText: '#fff' },
			tertiary: { light: '#e8d6ee', main: '#cba0d7', dark: '#ae6ac0', contrastText: '#fff' },
			text: { primary: '#06253b', secondary: '#0d5180', disabled: '#c3cdd4' }
		},
		shape: { borderRadius: 8 },
		typography: {
			fontFamily: `${IranSansXFont.style.fontFamily}, ${RobotoFont.style.fontFamily}`,
			fontSize: 14
		},
		components: {
			MuiCssBaseline: {
				styleOverrides: {
					body: { scrollBehavior: 'smooth' },
					a: { textDecoration: 'none' },
					'@media print': { html: { zoom: '1 !important' } }
				}
			},
			// documentElement zoom (desktop ui_scale) breaks Popper/Popover anchor math
			MuiPopper: {
				defaultProps: {
					modifiers: uiScalePopperModifiers
				}
			},
			MuiTooltip: {
				defaultProps: {
					slotProps: {
						popper: {
							modifiers: uiScalePopperModifiers
						}
					}
				}
			},
			MuiAutocomplete: {
				defaultProps: {
					slotProps: {
						popper: {
							modifiers: uiScalePopperModifiers
						}
					}
				}
			},
			MuiPopover: {
				defaultProps: {
					slotProps: {
						transition: uiScalePopoverTransitionSlotProps
					}
				}
			},
			MuiMenu: {
				defaultProps: {
					slotProps: {
						transition: uiScalePopoverTransitionSlotProps
					}
				}
			}
		},
		breakpoints: {
			values: {
				xs: 0,
				sm: 600,
				md: 900,
				lg: 1200,
				xl: 1536,
				x2l: 1760
			}
		}
	})

export default ThemeConfig
